import { accountHeader, authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnCreate } from '@helpers/product-events';
import { KnowledgeBaseType } from '@constants/knowledge-base';

export const knowledgeBaseService = {
    getKnowledgeBase,
    addOrUpdateKnowledgeBase,
    saveDocument,
    assignAgents,
    deleteKnowledgeBase,
};

function getKnowledgeBase(params, page, pageSize) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(params),
    };

    return fetch(`${BASE_URL}api/chat-bot/knowledge-base/list?page=${page}&pageSize=${pageSize}`, requestOptions).then(
        handleResponse,
    );
}

function addOrUpdateKnowledgeBase(data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/chat-bot/knowledge-base`, requestOptions)
        .then(handleResponse)
        .then(captureOnCreate(data, ProductEvent.KnowledgeBaseItemCreated, () => ({ type: data.type })));
}

function saveDocument(id, data) {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestOptions = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + user.token,
            ...accountHeader(),
        },
        body: data,
    };

    return fetch(`${BASE_URL}api/chat-bot/knowledge-base/documents`, requestOptions)
        .then(handleResponse)
        .then(captureOnCreate({ id }, ProductEvent.KnowledgeBaseItemCreated, { type: KnowledgeBaseType.DOCUMENT }));
}

function assignAgents(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/chat-bot/knowledge-base/assign-agents`, requestOptions).then(handleResponse);
}

function deleteKnowledgeBase(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/chat-bot/knowledge-base/${id}`, requestOptions).then(handleResponse);
}
